export function initUIHelpers() {
    placeholderFix();
}

/* --------------------------------------------
 * Placeholder polyfill (for legacy forms)
 * -------------------------------------------- */
function placeholderFix() {
    const inputs = document.querySelectorAll('[placeholder]');
    if (!inputs.length) return;

    inputs.forEach(input => {
        const placeholder = input.getAttribute('placeholder');

        const handleFocus = () => {
            if (input.value === placeholder) {
                input.value = '';
                input.classList.remove('placeholder');
            }
        };

        const handleBlur = () => {
            if (input.value === '' || input.value === placeholder) {
                input.classList.add('placeholder');
                input.value = placeholder;
            }
        };

        input.addEventListener('focus', handleFocus);
        input.addEventListener('blur', handleBlur);
        // Initialize state
        handleBlur();
    });

    // On form submit: clear placeholders
    const forms = new Set(Array.from(inputs).map(i => i.form).filter(Boolean));
    forms.forEach(form => {
        form.addEventListener('submit', () => {
            form.querySelectorAll('[placeholder]').forEach(input => {
                if (input.value === input.getAttribute('placeholder')) {
                    input.value = '';
                }
            });
        });
    });
}
